// extracted by mini-css-extract-plugin
module.exports = {"Button":"buttons_Button__39E4r","defaultButton":"buttons_defaultButton__2VMPz","greenButton":"buttons_greenButton__p5Cza","redButton":"buttons_redButton__2kryf"};